import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import "@/styles/CTASection.css";

const CTASection = () => {
  return (
    <section className="cta-section" data-testid="cta-section">
      <div className="cta-overlay"></div>
      <div className="container">
        <div className="cta-content">
          <h2 className="cta-title" data-testid="cta-title">
            ¿Listo para Comenzar tu Proyecto?
          </h2>
          <p className="cta-description" data-testid="cta-description">
            Contáctanos hoy y convierte tu visión en realidad con Pimot Construcciones
          </p>
          <Link to="/contacto" className="cta-button" data-testid="cta-contact-btn">
            Contáctanos Ahora
            <ArrowRight size={20} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTASection;